import type { UserDetailsModalFormProps } from './types'

export const initialFormValues: UserDetailsModalFormProps = {
  id: '',
  profitCenterCode: '',
  businessUnit: '',
  segment: '',
  directorate: '',
  profitCenter: '',
  profitCenterName: '',
  profitCenterType: '',
  cep: '',
  address: '',
  number: '',
  neighborhood: '',
  city: '',
  uf: '',
  email: '',
  regional: '',
  managerAreaName: '',
  managerAreaEmail: ''
}
